/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@ngx-translate/core/src/translate.pipe';
import * as i2 from '@ngx-translate/core/src/translate.service';
import * as i3 from 'ngx-bootstrap/dropdown/bs-dropdown.state';
import * as i4 from 'ngx-bootstrap/dropdown/bs-dropdown.directive';
import * as i5 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i6 from 'ngx-bootstrap/dropdown/bs-dropdown.config';
import * as i7 from 'ngx-bootstrap/dropdown/bs-dropdown-toggle.directive';
import * as i8 from 'ngx-bootstrap/dropdown/bs-dropdown-menu.directive';
import * as i9 from '../../../../../src/app/dashboard/user-menu/dashboard-user-menu.component';
import * as i10 from '../../../../../src/app/modules/auth/auth.service';
var styles_DashboardUserMenuComponent = [];
export var RenderType_DashboardUserMenuComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_DashboardUserMenuComponent, data: {} });
function View_DashboardUserMenuComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 5, 'ul', [['class',
                'dropdown-menu']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 2, 'li', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.logout() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef]),
        (_l()(), i0.ɵted(null, ['\n    ']))], null, function (_ck, _v) {
        var currVal_0 = i0.ɵunv(_v, 3, 0, i0.ɵnov(_v, 4).transform('Logout'));
        _ck(_v, 3, 0, currVal_0);
    });
}
export function View_DashboardUserMenuComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(16777216, null, null, 15, 'div', [['class', 'user-menu-content'], ['dropdown', '']], [[2, 'dropup', null],
            [2, 'open', null], [2, 'show', null]], null, null, null, null)), i0.ɵprd(512, null, i3.BsDropdownState, i3.BsDropdownState, []), i0.ɵdid(212992, null, 0, i4.BsDropdownDirective, [i0.ElementRef,
            i0.Renderer, i0.ViewContainerRef, i5.ComponentLoaderFactory, i6.BsDropdownConfig,
            i3.BsDropdownState], null, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 7, 'a', [['class', 'menu-header'],
            ['dropdownToggle', '']], [[1, 'aria-haspopup', 0], [1, 'disabled', 0], [1, 'aria-expanded',
                0]], [[null, 'click'], ['document', 'click'], [null, 'keyup.esc']], function (_v, en, $event) {
            var ad = true;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 5).onClick() !== false);
                ad = (pd_0 && ad);
            }
            if (('document:click' === en)) {
                var pd_1 = (i0.ɵnov(_v, 5).onDocumentClick($event) !== false);
                ad = (pd_1 && ad);
            }
            if (('keyup.esc' === en)) {
                var pd_2 = (i0.ɵnov(_v, 5).onEsc() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(147456, null, 0, i7.BsDropdownToggleDirective, [i3.BsDropdownState, i0.ElementRef], null, null), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 0, 'img', [['alt',
                'user picture']], [[8, 'src', 4]], null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(),
            i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_DashboardUserMenuComponent_1)),
        i0.ɵdid(16384, null, 0, i8.BsDropdownMenuDirective, [i3.BsDropdownState,
            i0.ViewContainerRef, i0.TemplateRef], null, null), (_l()(),
            i0.ɵted(null, ['\n']))], function (_ck, _v) {
        _ck(_v, 2, 0);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = i0.ɵnov(_v, 2).dropup;
        var currVal_1 = i0.ɵnov(_v, 2).isOpen;
        var currVal_2 = (i0.ɵnov(_v, 2).isOpen && i0.ɵnov(_v, 2).isBs4);
        _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2);
        var currVal_3 = true;
        var currVal_4 = i0.ɵnov(_v, 5).isDisabled;
        var currVal_5 = i0.ɵnov(_v, 5).isOpen;
        _ck(_v, 4, 0, currVal_3, currVal_4, currVal_5);
        var currVal_6 = i0.ɵinlineInterpolate(1, '', _co.user.picture, '');
        _ck(_v, 7, 0, currVal_6);
        var currVal_7 = _co.user.name;
        _ck(_v, 10, 0, currVal_7);
    });
}
export function View_DashboardUserMenuComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'cx-dashboard-usermenu', [], null, null, null, View_DashboardUserMenuComponent_0, RenderType_DashboardUserMenuComponent)), i0.ɵdid(114688, null, 0, i9.DashboardUserMenuComponent, [i10.AuthService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var DashboardUserMenuComponentNgFactory = i0.ɵccf('cx-dashboard-usermenu', i9.DashboardUserMenuComponent, View_DashboardUserMenuComponent_Host_0, {}, {}, []);
//# sourceMappingURL=dashboard-user-menu.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/dashboard/user-menu/dashboard-user-menu.component.ngfactory.js
// module id = 1186
// module chunks = 0